import React from 'react';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { Checkin } from 'src/api/types/checkin-types';
import { listRow } from '../styles';

type Props = {
  entry: Checkin;
  onSendPromo: (entry: Checkin) => void;
  sending: boolean;
  hasLocation: boolean;
  formatDate: (value: number) => string;
  labels: {
    unknownVisitor: string;
    optIn: string;
    noOptIn: string;
    sendOne: string;
  };
};

const CheckinRow: React.FC<Props> = ({
  entry,
  onSendPromo,
  sending,
  hasLocation,
  formatDate,
  labels,
}) => (
  <Stack
    direction={{ xs: 'column', md: 'row' }}
    spacing={1}
    alignItems={{ xs: 'flex-start', md: 'center' }}
    justifyContent="space-between"
    sx={listRow}>
    <Box sx={{ flex: 1 }}>
      <Typography variant="subtitle1" fontWeight={600}>
        {entry.name || labels.unknownVisitor}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ wordBreak: 'break-word' }}>
        {entry.email}
      </Typography>
      <Stack direction="row" spacing={1} mt={0.75} flexWrap="wrap">
        <Chip
          size="small"
          label={entry.optIn ? labels.optIn : labels.noOptIn}
          color={entry.optIn ? 'success' : 'default'}
          variant={entry.optIn ? 'filled' : 'outlined'}
        />
        <Chip
          size="small"
          label={formatDate(entry.createdAt || Date.now())}
          variant="outlined"
        />
      </Stack>
    </Box>
    <Button
      size="small"
      variant="text"
      startIcon={<SendIcon />}
      onClick={() => onSendPromo(entry)}
      disabled={sending || !entry.email || !hasLocation}>
      {labels.sendOne}
    </Button>
  </Stack>
);

export { CheckinRow };
